import {
  ASSET_REVENUE_REPORT_DOWNLOAD_START,
  ASSET_REVENUE_REPORT_DOWNLOAD_STOP,
  ASSET_REVENUE_REPORT_SUCCESS,
  FETCH_IDEAL_DAYS_FAILED,
  FETCH_IDEAL_DAYS_START,
  FETCH_IDEAL_DAYS_SUCCESS,
  FETCH_LEASING_CALCULATION_SUCCESS,
  FETCH_LEASING_COST_FAILED,
  FETCH_LEASING_COST_START,
  FETCH_LEASING_COST_SUCCESS,
  FETCH_LEASING_REVENUE_FAILED,
  FETCH_LEASING_REVENUE_START,
  FETCH_LEASING_REVENUE_SUCCESS,
  FETCH_LEASING_STATUS_FAILED,
  FETCH_LEASING_STATUS_START,
  FETCH_LEASING_STATUS_SUCCESS,
  FETCH_LEASING_SUCCESS,
  LEASING_COST_CALCULATION,
  REMOVE_IMAGE_SUCCESS,
  UPDATE_LEASING_DESCRIPTION_FAIL,
  UPDATE_LEASING_DESCRIPTION_SUCCESS,
  UPLOAD_IMAGE_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  query: {},
  leaseInfo: {},
  uploadData: {},
  removeData: '',
  leasingStatus: {},
  assetCost: {},
  assetRevenue: {},
  leasingStatusLoading: {},
  idealDays: {},
  revenueReportData: [],
  downloadStart: false,
  downloadData: [],
  costCalculationData: [],
  calculationData: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_LEASING_SUCCESS: {
      const query = {...state.query};
      //query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        resources: action.data,
        //total: action.total,
      }
    }

    case UPDATE_LEASING_DESCRIPTION_SUCCESS: {
      return {
        ...state,
        leaseInfo: action.data,
      }
    }

    case UPDATE_LEASING_DESCRIPTION_FAIL: {
      return {
        ...state,
        leaseInfo: {},
      }
    }

    case UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        uploadData: action.data,
      }
    }

    case REMOVE_IMAGE_SUCCESS: {
      return {
        ...state,
        removeData: action.data,
      }
    }

    case FETCH_LEASING_STATUS_SUCCESS: {
      return {
        ...state,
        leasingStatus: {id: action.id, status: action.data, loading: false},
        // leasingStatusLoading: {id: action.id, loading: false}
      }
    }

    case FETCH_LEASING_STATUS_FAILED: {
      return {
        ...state,
        leasingStatus: {id: action.id, status: null, loading: false},
        // leasingStatusLoading: {id: action.id, loading: false}
      }
    }

    case FETCH_LEASING_STATUS_START: {
      return {
        ...state,
        leasingStatus: {id: action.id, status: null, loading: true},
      }
    }

    case FETCH_LEASING_COST_SUCCESS: {
      return {
        ...state,
        assetCost: {id: action.id, cost: action.data, loading: false},
        // leasingStatusLoading: {id: action.id, loading: false}
      }
    }

    case FETCH_LEASING_COST_FAILED: {
      return {
        ...state,
        assetCost: {id: action.id, cost: null, loading: false},
        // leasingStatusLoading: {id: action.id, loading: false}
      }
    }

    case FETCH_LEASING_COST_START: {
      return {
        ...state,
        assetCost: {id: action.id, cost: null, loading: true},
      }
    }

    case FETCH_LEASING_REVENUE_SUCCESS: {
      return {
        ...state,
        assetRevenue: {id: action.id, revenue: action.data, loading: false},

      }
    }

    case FETCH_LEASING_REVENUE_FAILED: {
      return {
        ...state,
        assetRevenue: {id: action.id, revenue: null, loading: false},

      }
    }

    case FETCH_LEASING_REVENUE_START: {
      return {
        ...state,
        assetRevenue: {id: action.id, revenue: null, loading: true},
      }
    }

    case FETCH_IDEAL_DAYS_SUCCESS: {
      return {
        ...state,
        idealDays: {id: action.id, days: action.data, loading: false},

      }
    }

    case FETCH_IDEAL_DAYS_FAILED: {
      return {
        ...state,
        idealDays: {id: action.id, days: null, loading: false},

      }
    }

    case FETCH_IDEAL_DAYS_START: {
      return {
        ...state,
        idealDays: {id: action.id, days: null, loading: true},
      }
    }

    case ASSET_REVENUE_REPORT_SUCCESS: {
      return {
        ...state,
        revenueReportData: action.data,
      }
    }

    case ASSET_REVENUE_REPORT_DOWNLOAD_START: {
      return {
        ...state,
        downloadStart: true,
      }
    }
    case ASSET_REVENUE_REPORT_DOWNLOAD_STOP: {
      return {
        ...state,
        downloadStart: false,
        downloadData: action.data,
      }
    }
    case LEASING_COST_CALCULATION: {
      return {
        ...state,
        costCalculationData: action.data
      }
    }

    case FETCH_LEASING_CALCULATION_SUCCESS: {
      return {
        ...state,
        calculationData: action.data
      }
    }
    default:
      return state;
  }
}

